import moment from "moment";
import { useEffect, useState } from "react";

import { getSupaClient } from "../../lib/supabase";

const defaultTimeFormat = "YYYY-MM-DDTHH:mm:ssZ";

/**
 * This hook fetches Discord or Slack weekly message counts between two dates
 *
 * @param  endTime - end of time period
 * @param  teamId - guild id for Dicord, team id for Slack
 * @param  platform - "slack" for Slack, "discord" for Discord
 * @returns An object --> { weeklyMessageCount: array of weekly messages count, loading: "true" when loading data, "false" when done}
 */
const useWeeklyMessageCount = (endTime, teamId, platform) => {
  const [weeklyMessageCount, setWeeklyMessageCount] = useState([]);
  const [loading, setLoading] = useState(true);
  const supabase = getSupaClient();
  const startTime = moment(endTime)
    .subtract(30, "day")
    .format(defaultTimeFormat);

  const teamOrGuild = {
    slack: "team_id",
    discord: "guild_id",
  };

  const params = {
    start_time: startTime,
    end_time: endTime,
    [teamOrGuild[platform]]: teamId,
  };

  const loadWeeklyMessagesMetrics = async () => {
    setLoading(true);

    let newData;
    if (platform === "slack") {
      const { data } = await supabase.rpc("messages_count_week", params);
      if (data) {
        newData = data.map((item, index) => {
          return {
            total_count: index === data.length - 1 ? null : item.total_count,
            week: moment(item.week).format("MM/DD/YY"),
            current: index >= data.length - 2 ? item.total_count : null,
            label: index === data.length - 1 ? "Ongoing" : null,
          };
        });
      }
      setWeeklyMessageCount(newData);
      setLoading(false);
    } else if (platform === "discord") {
      const { data } = await supabase.rpc(
        "discord_messages_count_week",
        params
      );
      if (data) {
        newData = data.map((item, index) => {
          return {
            total_count: index === data.length - 1 ? null : item.total_count,
            week: moment(item.week).format("MM/DD/YY"),
            current: index >= data.length - 2 ? item.total_count : null,
            label: index === data.length - 1 ? "Ongoing" : null,
          };
        });
      }
      setWeeklyMessageCount(newData);
      setLoading(false);
    }
  };

  useEffect(() => {
    loadWeeklyMessagesMetrics();
  }, [startTime, endTime]);

  return { weeklyMessageCount, loading };
};

export default useWeeklyMessageCount;
